import { LoadingSpinner } from '../loading-spinner';
import { Icon, Text } from '../../foundations';
import styles from './StatusOverlay.module.css';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

export type CommonTranslationKeys = 'DATA_BEING_VALIDATED' | 'DATA_VALIDATED_AND_SAVED';

export type OverlayStatus = 'loading' | 'success' | 'error';

export interface StatusOverlayProps {
	status: OverlayStatus;
	messageKey: CommonTranslationKeys;
	isOpen: boolean;
}

export const StatusOverlay = ({ status, messageKey, isOpen }: StatusOverlayProps) => {
	const { t } = useTranslation('common');

	if (!isOpen) {
		return null;
	}

	const renderContent = () => {
		switch (status) {
			case 'loading':
				return <LoadingSpinner size="big" />;
			case 'success':
				return <Icon name="validar" className={clsx(styles.icon, styles.success)} />;
			case 'error':
				return <Icon name="alertas" className={clsx(styles.icon, styles.error)} />;
			default:
				return null;
		}
	};

	return (
		<div className={styles.overlay} role="dialog" aria-live="assertive">
			<div className={styles.content}>
				{renderContent()}
				<Text font="verdana" className={styles.title}>
					{t(messageKey)}
				</Text>
			</div>
		</div>
	);
};
